import { render } from "./restyleMobileLayout.vue?vue&type=template&id=380d3080&scoped=true"
import script from "./restyleMobileLayout.vue?vue&type=script&lang=js"
export * from "./restyleMobileLayout.vue?vue&type=script&lang=js"

import "./restyleMobileLayout.vue?vue&type=style&index=0&id=380d3080&lang=scss"
import "./restyleMobileLayout.vue?vue&type=style&index=1&id=380d3080&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380d3080"]])

export default __exports__